<template>
<!-- snb -->
<nav id="snb">
    <section class="snb_sec mypage_wrap">
        <h2>{{ $t('TITLE.GLOBAL.MYPAGE') }}</h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myPage top 3 -->
                <li v-for="menu in myPageList">
                    <a href="javascript:" @click="handleMoveMenu(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="snb_sec mymenu_wrap">
        <h2>
            {{ $t('TITLE.GLOBAL.MYMENUS') }}
            <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnMyMenuConfig">
                <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
            </a>
        </h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myMenus top 3 -->
                <li v-for="menu in myMenusList">
                    <a href="javascript:" @click="handleMoveMenuByMenuId(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="snb_sec myctg_wrap">
        <h2>
            {{ $t('TITLE.GLOBAL.QUICKCATEGORY') }}
            <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnCatConfig">
                <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
            </a>
        </h2>
        <div class="list">
            <ul class="list_quickctg">
                <!-- myCategory top 3 -->
                <li v-for="cat in quickCategoryList">
                    <a
                        href="javascript:"
                        @click="setCategoryParam(cat.category1, cat.category2, cat.category3)"
                    >{{ cat.categoryNm }}</a>
                </li>
            </ul>
            <div v-if="isUndo" class="ctg_btn">
                <a  href="javascript:"
                    class="btn_white w100p"
                    :title="$t('BUTTON.GLOBAL.UNDO')"
                    @click="btnUndo()"
                >
                    {{ $t('BUTTON.GLOBAL.UNDO') }}
                </a>
            </div>
        </div>
    </section>

    <section class="bn_wrap">
        <ul class="list_banner">
            <li class="bn_box" v-if="!isASC">
                <a href="javascript:" class="ico_itvoc" :title="$t('TITLE.LEFT.MENU.ITVOC')" @click="btnITVOC">{{ $t('TITLE.LEFT.MENU.ITVOC') }}</a>
            </li>
            <li class="bn_box"><a href="javascript:" class="ico_support" :title="$t('TITLE.LEFT.MENU.SUPPORT')" @click="btnSupport">{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</a></li>
        </ul>
    </section>
</nav>
<!-- //snb -->
</template>

<script>
import Vue                          from 'vue';
import { mapGetters, mapActions }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import qs                           from 'query-string';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }        from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import MyMenuConfigPopup            from '~vb/common/MyMenuConfigPopup';
import CategoryConfigPopup          from '~vb/common/CategoryConfigPopup';
import ITVocViewPopupVue from './ITVocViewPopup.vue';

const fetchKnowledgeAllSetting = () => axios.post(`${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeAllSetup.skp`);
const fetchKnowledgeSetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeSetup.skp`,
    qs.stringify({ WORK_TYPE : workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'SKPSnb',
    data() {
        return {
            isASC: false,
            myPageList: [],
            myMenusList: [],
            quickCategoryList: [],

            isUndo: false
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo();
        },
        getMyPageList() {
            return this.myPages['subMenu'] || [];
        }
    },
    methods: {
        ...mapActions(['changeSubsidiary', 'setReturnSystem']),
        async initLoad() {
            if(Number(this.deptLevelCd) === 1) { this.isASC = true; }
            this.myPageList = this.getMyPageList;
            const resAll    = await fetchKnowledgeAllSetting();
            return resAll.data;
        },
        // myMenus 조회
        async searchMyMenusList() {
            Vue.$log.info('▶ SKPSnb.vue searchMyMenusList called.');
            return await fetchKnowledgeSetting('MENU')
                        .then(res => { this.setMyMenusList({ myMenus: res.data }); })
                        .catch(err => { SDLUtil.errorAlert(err); });
        },
        // myMenus 클릭 시 이벤트
        handleMoveMenuByMenuId(menuObj) {
            let menuId = menuObj.menuId3 || menuObj.menuId2 || menuObj.menuId1;
            let sMenu = _.find(MenuUtil.menuScan(menuId, this.menus), function(m) { return m.menuId == menuId });
            this.handleMoveMenu(sMenu);
        },
        // myMenus List 설정
        setMyMenusList(res) {
            // My Menus data setting
            let refineMyMenuslList = [], myMenusList = [];
            if(SDLUtil.isNull(res.myMenus.result)) {
                myMenusList = res.myMenus.rowData;   
            } else {
                myMenusList = res.myMenus.result.rowData;
            }

            if(myMenusList.length > 0) {
                myMenusList = _.sortBy(myMenusList, ["ROW_NUM"]);
                for(let menu of myMenusList) {
                    refineMyMenuslList.push({
                        menuNm: this.setLinkedName(menu.WORK_KEY_1_NM, menu.WORK_KEY_2_NM, menu.WORK_KEY_3_NM),
                        menuId1: menu.WORK_KEY_1 || '',
                        menuId2: menu.WORK_KEY_2 || '',
                        menuId3: menu.WORK_KEY_3 || '',
                    });
                };

                this.myMenusList = refineMyMenuslList;
            }
        },
        // Quick Category 조회
        async searchQuickCategoryList() {
            //console.log('▶ KnowledgeSnb > searchQuickCategoryList called.');
            return await fetchKnowledgeSetting('CATEGORY')
                        .then(res => { this.setQuickCategoryList({ quickCategory: res.data }); })
                        .catch(err => { SDLUtil.errorAlert(err); });
        },
        // Quick Category List 설정
        setQuickCategoryList(res) {
            // Quick Category data setting
            let refineCategoryList = [], quickCategoryList = [];
            if(SDLUtil.isNull(res.quickCategory.result)) {
                quickCategoryList = res.quickCategory.rowData;   
            } else {
                quickCategoryList = res.quickCategory.result.rowData;
            }

            if(quickCategoryList.length > 0) {
                quickCategoryList = _.sortBy(quickCategoryList, ["ROW_NUM"]);
                for(let category of quickCategoryList) {
                    refineCategoryList.push({
                        categoryNm: this.setLinkedName(category.WORK_KEY_1_NM, category.WORK_KEY_2_NM, category.WORK_KEY_3_NM),
                        category1: category.WORK_KEY_1 || '',
                        category2: category.WORK_KEY_2 || '',
                        category3: category.WORK_KEY_3 || '',
                    });
                };

                this.quickCategoryList = refineCategoryList;
                // KnowledgeSearch.vue 로 카테고리 리스트 전달
                EventBus.$emit('mobile-category', this.quickCategoryList);

            } else {
                this.quickCategoryList = [];
                // KnowledgeSearch.vue 로 카테고리 리스트 전달
                EventBus.$emit('mobile-category', this.quickCategoryList);
            }
        },
        // 선택한 Category param을 카테고리 컴포넌트로 전달 -> CategoryComboBox.vue
        setCategoryParam(cat1, cat2, cat3) {
            let catForm = {
                searchPRD_CATEGORY_CD1: cat1,
                searchPRD_CATEGORY_CD2: cat2,
                searchPRD_CATEGORY_CD3: cat3
            };

            // Call CategoryComboBox.vue setQuickCategoryParam method
            EventBus.$emit('quick-category', catForm);
            this.isUndo = true;
        },
        handleMoveMenu(menu) {
            store.commit(
                'PARAMS',
                Object.assign(
                    this.storeParams,
                    {
                        menuId : menu.menuId,
                        menuGrpCd : menu.menuGrpCd || '',
                        menuGrpDetailCd : menu.menuGrpDetailCd || '',
                        creationYn : menu.creationYn
                    }
                )
            );

            if(SDLUtil.isNull(menu['connUrl'])) {
                Vue.$log.warn('▶ SKPSnb.vue handleMoveMenu URL is null');
                return false;
            }

            let connUrl = menu.connUrl.replace('.skp', '');
            Vue.$log.info('▶ SKPSnb.vue handleMove select url : ', connUrl);
            this.$router.push(connUrl);
        },
        // SNB 태그 생성
        setLinkedName(name1, name2, name3) {
            let linkedName = [], gt = " > ";
            if(!SDLUtil.isNull(name1)) { linkedName.push(name1); }
            if(!SDLUtil.isNull(name2)) { linkedName.push(gt); linkedName.push(name2); }
            if(!SDLUtil.isNull(name3)) { linkedName.push(gt); linkedName.push(name3); }
            return linkedName.join("");
        },
        // IT VOC 팝업
        btnITVOC() {
/*             SDLUtil.show(
                ITVocViewPopupVue,
                {},
                { height: 'auto' }
            ); */
             SDLUtil.openLegacyWindowPopup({
                 //url: 'http://it4u.sec.samsung.net/itvoc/jsp/itvoclink/itvocLst.jsp?sysCode=02P022701D0227',
                 url: 'http://itvoc.sec.samsung.net/it4u/voc/vocReg?directCode=02P022701D0227',
                 title: SDLUtil.getMsgProp('TITLE.LEFT.MENU.ITVOC'),
                 w: 1024,
                 h: 760
             });
        },
        async btnSupport() {
            let reLoginData = { loginSystem : 'SUPPORT' };
            this.setReturnSystem(this.loginSystem);
            if(Number(this.deptLevelCd) === 1) {
                Object.assign(reLoginData, {
                    topRhqCd : this.loginRhq,
                    topSubsidiaryCd : this.userCorpCd,
                });

            } else {
                Object.assign(reLoginData, {
                    topRhqCd : $('#selectRhqCd :selected').val(),
                    topRhqNm : $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd : $('#selectRhqSubCd :selected').val(),
                    topSubsidiaryNm : $('#selectRhqSubCd :selected').html(),
                });
            };

            SDLUtil.showLoadingBar(true);
            const loginResult = await this.changeSubsidiary(reLoginData)
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });

            this.afterLoginProcess(loginResult);
        },
        // Support 변경 후 처리
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            EventBus.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        // 메인 호출 이벤트
        gotoMain() {
            window.scrollTo(0, 0);
            this.$router.push(MenuUtil.getSupportMain());
        },

        // My Menu config
        btnMyMenuConfig() {
            SDLUtil.show(
                MyMenuConfigPopup,
                {
                    rtnFunc: () => {
                        // 팝업 닫은 후 내 메뉴 리로드
                        this.searchMyMenusList();
                    }
                },
                { height: 'auto' }
            );
        },
        // Quick Category config
        btnCatConfig() {
            SDLUtil.show(
                CategoryConfigPopup,
                {
                    rtnFunc: () => {
                        // 팝업 닫은 후 카테고리 리로드
                        this.searchQuickCategoryList();
                    }
                },
                { height: 'auto' }
            );
        },

        btnUndo() {
            // 카테고리 초기화
            this.setCategoryParam('', '', '');
            this.isUndo = false;
        },
        resetUndo() {
            this.isUndo = false;
        }
    },
    created() {
        Vue.$log.info('▶ SKPSnb.vue created.');
        EventBus.$on('main-snb-undo-reset', () => { this.resetUndo(); });
        this.initLoad()
            .then(res => {
                this.setMyMenusList(res);
                this.setQuickCategoryList(res);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });
    },
    beforeDestroy() {
        Vue.$log.info('▶ SKPSnb.vue beforeDestroy.');
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/SKPSnb.vue